class GiftProduct extends HTMLElement {
    constructor() {
        super();
        this.id = parseInt(this.dataset.id);
        this.matchqty = this.dataset.matchqty;
        this.giftqty = parseInt(this.dataset.giftqty);
        this.CompareProductQty = parseInt(this.dataset.compareproductqty);
        this.totalqty = this.CompareProductQty - this.giftqty;
        this.removetotalqty = this.CompareProductQty;

        // this.toggleSwitch = localStorage.getItem("gift");
        this.checkqty();
    }

    checkqty(){
        // debugger
        // if(this.toggleSwitch == 'true'){
            if(this.totalqty < 0){
                this.removelifetimeWarranty(this.removetotalqty)
            }else if(this.matchqty == 'false'){
                this.addlifetimeWarranty(this.CompareProductQty)
            }
        // }
    }

    async addlifetimeWarranty(qty) {
        const sections = this.getSectionsToRender().map((section) => section.id);

        const body = JSON.stringify({
        id: this.id,
        quantity: qty,
        sections: sections,
        sections_url: window.location.pathname,
        });

        try {
        const response = await fetch(`${routes.cart_change_url}`, {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            Accept: `application/json`,
            },
            body,
        });

        if (response.status === 422) {
            const errorData = await response.json();
            // Handle error (e.g., show a notification)
            console.error("Error adding item to cart:", errorData.description);
            return;
        }

        const parsedState = await response.json();
        this.renderContents(parsedState);
        } catch (error) {
        console.error("Error adding item to cart:", error);
        }
    }

    async removelifetimeWarranty(qty) {
        const sections = this.getSectionsToRender().map((section) => section.id);

        const body = JSON.stringify({
        id: this.id,
        quantity: qty,
        sections: sections,
        sections_url: window.location.pathname,
        });

        try {
        const response = await fetch(`${routes.cart_change_url}`, {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            Accept: `application/json`,
            },
            body,
        });

        if (response.status === 422) {
            const errorData = await response.json();
            // Handle error (e.g., show a notification)
            console.error("Error adding item to cart:", errorData.description);
            return;
        }

        const parsedState = await response.json();
        this.renderContents(parsedState);
        } catch (error) {
        console.error("Error adding item to cart:", error);
        }
    }

    renderContents(parsedState) {
        document.querySelector(".drawer__inner").classList.contains("is-empty") &&
        document.querySelector(".drawer__inner").classList.remove("is-empty");
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
        if (!sectionElement) return;
        if (section.id == "cart-drawer" || section.selector == "#CartDrawer") {
            const newCartDrawer = this.getSectionDOM(
            parsedState.sections[section.id],
            section.selector
            );
        // debugger
            updateCartDrawer(sectionElement, newCartDrawer);
        } else {
            sectionElement.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
            );
        }
        });
    }

    getSectionDOM(html, selector = ".shopify-section") {
        return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector);
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
        {
            id: "cart-drawer",
            selector: "#CartDrawer",
        },
        {
            id: "cart-icon-bubble",
        },
        ];
    }
}


customElements.define('gift-product', GiftProduct);